import { translateToEmpty, translateToDate, translateToYuan, translateByDict } from '@/utils/translators'

export const formatToEmpty = (row, column, cellValue) => translateToEmpty(cellValue)

export const formatToDate = (row, column, cellValue) => translateToDate(cellValue)

export const formatToYuan = (row, column, cellValue) => translateToYuan(cellValue)

export const formatToLabel = dict => (row, column, cellValue) => translateByDict(cellValue, dict, 'code', 'name')
